import { StyleSheet } from 'react-native';
import {
  fontSizeMedium,
  errorRed,
  fontFamilyBold,
  lightPurple,
  fontFamilySemiBold,
  fontSizeSmall,
} from '../../constants/palette';

const styles = StyleSheet.create({
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkEmailText: {
    fontSize: fontSizeMedium,
    textAlign: 'center',
  },
  emailContainer: {
    paddingBottom: 20,
    width: 250, // FIXME: HACK
  },
  emailText: {
    fontSize: fontSizeMedium,
    fontFamily: fontFamilyBold,
    textAlign: 'center',
  },
  errorContainer: {
    marginTop: 10,
    marginBottom: 10,
    width: 250,
  },
  logo: {
    marginBottom: 40,
  },
  resendLink: {
    textAlign: 'center',
    color: lightPurple,
    fontFamily: fontFamilySemiBold,
    fontSize: fontSizeSmall,
  },
  verifyErrorText: {
    color: errorRed,
    textAlign: 'center',
    fontWeight: 'bold',
    width: 250,
  },
  subHeader: {
    marginBottom: 20,
    width: 250,
    textAlign: 'center',
  },
});

export default styles;
